import { render, staticRenderFns } from "./AuthorImage.vue?vue&type=template&id=feedb35e&scoped=true"
import script from "./AuthorImage.vue?vue&type=script&lang=js"
export * from "./AuthorImage.vue?vue&type=script&lang=js"
import style0 from "./AuthorImage.vue?vue&type=style&index=0&id=feedb35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feedb35e",
  null
  
)

export default component.exports